
/**
 * Email Service
 * Integrated with EmailJS (Free Tier)
 * To use: Register at emailjs.com, create a template, and update the IDs below.
 */

const EMAILJS_SERVICE_ID = ''; // Placeholder: Replace with your Service ID
const EMAILJS_TEMPLATE_ID = 'template_qv6raer'; // Placeholder: Replace with your Template ID
const EMAILJS_PUBLIC_KEY = ''; // Placeholder: Replace with your Public Key

export const emailService = {
  /**
   * Sends a real registration invite to a nominee email.
   */
  async sendNomineeInvite(email: string, nomineeName: string, ownerName: string): Promise<{ success: boolean; error?: string }> {
    console.log(`[EmailService] Initiating real transmission for ${email}...`);
    
    const data = {
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: {
        to_email: email,
        to_name: nomineeName,
        from_name: ownerName,
        signup_link: `https://nominee-desk.app/signup?email=${encodeURIComponent(email)}`,
        message: `${ownerName} has securely listed you as a beneficiary in their digital heritage vault on NomineeDesk.`
      }
    };

    try {
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        console.log(`[EmailService] Email successfully delivered to ${email}`);
        return { success: true };
      } else {
        const errorText = await response.text();
        console.error(`[EmailService] API Error: ${errorText}`);
        // If IDs are default/placeholders, it will fail here.
        return { success: false, error: 'Email service configuration required.' };
      }
    } catch (error) {
      console.error('[EmailService] Network Error:', error);
      return { success: false, error: 'Network connection failed.' };
    }
  }
};
